import React from 'react'
import "./scheduling.scss"
import AutomationScheduleAndAlert from './sections/automationScheduleAndAlert'
import Kapis from './sections/kapis'
import KnowEverythingBusiness from './sections/knowEverythingBusiness'
import LetsGo from '../connectors/letsgo'

function Scheduling() {
  return (
    <div className='container-scheduling'>
        <div className="section-section-automationScheduleAndAlert">
            <AutomationScheduleAndAlert />
        </div>
        <div className="section-KnowEverythingBusiness">
          <KnowEverythingBusiness />
        </div>
        <div className="section-Kapis">
          <Kapis />
        </div>
        <div className="section-letsgo">
          <LetsGo />
        </div>
    </div>
  )
}

export default Scheduling